export default __webpack_public_path__ + "static/media/available_tickets.a91df50b.svg";